import { render, staticRenderFns } from "./SHORT_ANSWER.vue?vue&type=template&id=04c78227&scoped=true&"
import script from "./SHORT_ANSWER.vue?vue&type=script&lang=js&"
export * from "./SHORT_ANSWER.vue?vue&type=script&lang=js&"
import style0 from "./SHORT_ANSWER.vue?vue&type=style&index=0&id=04c78227&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c78227",
  null
  
)

export default component.exports